import type { FaireProductEntity } from "../../entity_types/product";

export const p_6ecsjehzef: FaireProductEntity = {
  token: "p_6ecsjehzef",
  type: "product",
  name: "Wheat Field Dinner Napkin Set",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/4b29fea97faf39189aafefccf51e0b75b707b7a9502a7e80b78d29aa10ca9ef6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ae588defe80d73de319eb32370633aa74a79018aff4cd319beaa7297731eba66.jpeg"
  ],
  priceDollars: 15,
  description: "Dinner Napkin Set - 6 Pack\n\nBring style to the table. \n\nMessy fingers are as helpless against our Dinner Napkins as boring tablescapes are. The Geometry Dinner Napkin Set transforms ordinary meals into festive events – no invitations required. Created from our soft, durable Geosuede(™) fabric and available in countless prints and patterns, you’re sure to invite these back to the table. Sold as a set of 6.\n\n...\n\n♺ Made from post-consumer recycled materials\n\n19\" x 19\"\n\nSet of 6 dinner napkins\n\nSingle-sided print\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n...\n\nDine Responsibly.\n\nWith its natural softness and ultra-absorbent weave, our Dinner Napkin Sets are guaranteed a seat at your table – but they’re also friendly to the environment. Our Dinner Napkins are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. And due to its weave, high absorbency and quick dry time, you can wash less often, helping to minimize yours. \n\n\n",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:38.959Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
